import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import TimeSelectorOption from "./option";
import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll";

export default class TimeSelectorPopoverContent extends React.Component {
    static propTypes = {
        selectedValue: PropTypes.object,
        timeStep: PropTypes.number,
        minValue: PropTypes.object,

        popoverMinWidth: PropTypes.number,

        onOptionClick: PropTypes.func
    };

    componentDidMount() {
        if (this.selectedOption) {
            const selectedNode = findDOMNode(this.selectedOption);
            this.scroll.setScrollTop(selectedNode.offsetTop, false, 0);
        }
    }

    render() {
        const options = [];
        const startMoment = this.props.minValue ? Moment(this.props.minValue) :
                            this.props.selectedValue ? Moment(this.props.selectedValue).startOf('day') :
                            Moment().startOf('day');

        // 24 hours is 96 steps of 15 minutes (this.props.timeStep)
        const steps = Math.floor(24 * 60 / this.props.timeStep);

        for (let i = 0; i < steps; i++) {
            const option = Moment(startMoment).add(this.props.timeStep * i, 'minutes');
            options.push(option)
        }

        // option to scroll to, equals to selected value or 8:00 if no value selected
        const scrollToValue = this.props.selectedValue ? this.props.selectedValue : Moment().hours(8).minutes(0);

        return (
            <VScroll ref={r=>this.scroll = r} containerStyle={{maxHeight:(window.innerHeight / 2) - 100}} minDragHeight={20}>
                <div className="ui5-popover-menu" style={this.props.popoverMinWidth ? {minWidth: this.props.popoverMinWidth} : null}>
                    {_.map(options, (value,key)=>{
                        const isSelected = value.isSame(this.props.selectedValue,'minute');
                        const isScrollTo = value.isSame(scrollToValue,'minute');
                        return <TimeSelectorOption ref={r=>{if(isScrollTo) this.selectedOption = r}}
                                                   key={key}
                                                   diffValue={this.props.minValue}
                                                   value={value}
                                                   isSelected={isSelected}
                                                   onClick={this.props.onOptionClick}/>
                    })}
                </div>
            </VScroll>
        );
    }
}